export default () => {
  const tabs = document.querySelectorAll('.about-tabs .tab')
  if (!tabs.length) return
  const contents = document.querySelectorAll('.tab-content')

  Array.from(tabs).forEach(function (tab) {
    tab.addEventListener('click', function () {
      const tabId = this.getAttribute('data-content')
      hideAllContents()
      const contentById = document.querySelector(
        `.tab-content[data-content='${tabId}']`
      )
      contentById.classList.add('active')
      tab.classList.add('active')
      return
    })
  })

  function hideAllContents() {
    Array.from(contents).forEach(function (content) {
      content.classList.remove('active')
    })
    Array.from(tabs).forEach(function (tab) {
      tab.classList.remove('active')
    })
  }
}
